import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from "../../../i18next";
import { Row, Col } from 'reactstrap';

import { getPriceWithCurrencySymbol } from '../../../utils/CommonUtils';
import SectionTitle from '../customerInsightScreen/SectionTitle';
import GeneralValueItem from '../customerInsightScreen/GeneralValueItem';

class GeneralStatistics extends Component {

    renderOderTotal() {
        return (
            <GeneralValueItem
                //colSize={2}
                icon="shopping_cart"
                iconSize="60"
                //TODO
                value={this.props.currentWeek.orderCount}
                label={i18n.t('screens:restaurantInsightScreen.orders')}
                valueFontSize={26}
                type="restaurantInsight"
            />
        );
    }

    renderTotalSpent() {
        return (
            <GeneralValueItem
                icon="wallet"
                iconSize="60"
                value={getPriceWithCurrencySymbol(this.props.currentWeek.orderTotal, this.props.currency)}
                label={i18n.t('screens:restaurantInsightScreen.totalSpent')}
                valueFontSize={26}
                type="restaurantInsight"
            />
        );
    }

    renderOderAverage = () => {
        return (
            <GeneralValueItem
                //colSize={2}
                icon="average"
                iconSize="60"
                //TODO
                value={getPriceWithCurrencySymbol(this.props.currentWeek.averageTotal, this.props.currency)}
                label={i18n.t('screens:restaurantInsightScreen.averageRestaurantInsight')}
                valueFontSize={26}
                type="restaurantInsight"
            />
        );
    }

    // renderUnqueCustomers() {
    //     return(
    //         <GeneralValueItem
    //             //colSize={2}
    //             icon="people"
    //             iconSize="60"
    //             value={this.props.restaurantInsight.uniqueCustomersCount}
    //             label={i18n.t('screens:restaurantInsightScreen.uniqueCustomers')}
    //             valueFontSize={26}
    //             type="restaurantInsight"
    //         />
    //     )
    // }

    // renderOrderFrequencyPerDay() {
    //     const valueText = `${this.props.restaurantInsight.orderFrequencyCount} order/s each ${this.props.restaurantInsight.orderFrequencyDays} day/s.`;
    //     return(
    //         <GeneralValueItem
    //             //colSize={2}
    //             icon="lifetime"
    //             iconSize="50"
    //             value={this.props.restaurantInsight.orderFrequencyDays}
    //             label={valueText}
    //             valueFontSize={26}
    //             type="restaurantInsight"
    //         />
    //     )
    // }

    // renderOrdersLastYear() {
    //     return(
    //         <GeneralValueItem
    //             //colSize={2}
    //             icon="shopping_cart_orders_last_year"
    //             iconSize="60"
    //             value={this.props.restaurantInsight.lastYearRevenue.ordersCount}
    //             label={i18n.t('screens:restaurantInsightScreen.ordersLastYear')}
    //             valueFontSize={26}
    //             type="restaurantInsight"
    //         />
    //     )
    // }

    renderGeneralStatistics() {
        return(
            <div>
            <Row style={{display:'flex', justifyContent:'space-evenly', margin:'0px 10px 0px 10px'}} >
                 {this.renderOderTotal()}
                 {this.renderTotalSpent()}
                 {this.renderOderAverage()}
                 {/* {this.renderUnqueCustomers()} */}
                 {/* {this.renderOrderFrequencyPerDay()} */}
                 {/* {this.renderOrdersLastYear()} */}
            </Row>
        </div>
        )
    }

    render () {
        const { timelineContainer, colContainerStyle, mainContainer, flexSpace } = styles;

       return (
         <Col style={colContainerStyle}>
         <div style={mainContainer}>
             <div style={flexSpace}>
                <div style={{marginLeft:'0px 27px 0px 27px'}}>
                    <SectionTitle title={i18n.t('screens:restaurantInsightScreen.generalStatisticsTitle')} />
                </div>
                
             </div>
             {this.renderGeneralStatistics()}
         </div>
     </Col>
       ) 
    }
}

const mapStateToProps = state => {
    return {
        restaurantInsight: state.restaurantInsight,
    }
};

export default connect(mapStateToProps) (GeneralStatistics);

const styles = {
    colContainerStyle: {
        padding: '15px',
        margin: '0px 35px 0px 35px'
    },
    mainContainer: {
        backgroundColor: 'white ',
        padding: '0',
        height: '253px'
        // overflow: 'scroll',
        // overflowX: 'hidden'
    },
    flexSpace: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    timelineContainer: {
        margin: '10px 40px',
        padding: '10px 0',
        // borderLeft: '2px solid rgb(209,197,211)',
        // borderRight: '2px solid rgb(209,197,211)',
        minHeight: '650px',
        backgroundColor: 'white'
    },
};


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/GeneralStatistics.js